<template>
    <b-modal
            id="edit-session-modal"
            :title="title"
            v-model="showModal"
            centered no-close-on-backdrop
            @ok="handleOk"
            @cancel="handleCancel"
            @close="handleCancel">
        <b-overlay :show="isLoading" rounded="sm">

            <ErrorView :visible="isLoadingError" :errorValue="loadingErrorValue"/>

            <form v-if="isLoadingError == false" ref="form" v-on:submit.prevent="noop">
                <b-form-group
                        label="Name"
                        label-for="name-input"
                        invalid-feedback="Name is required (minimum 3 characters, max 128)"
                        :state="nameState">
                    <b-form-input
                            id="name-input"
                            placeholder="Enter name"
                            v-model="nameValue"
                            @keyup.enter.native="handleOk"
                            required>
                    </b-form-input>
                </b-form-group>

            </form>
        </b-overlay>
        <template v-slot:modal-footer="{ ok, cancel }">
            <b-button size="sm" variant="primary" @click="ok()">
                Save Changes
            </b-button>
            <b-button size="sm" variant="outline-secondary" @click="cancel()">
                Cancel
            </b-button>
        </template>

        <b-modal id="error-modal" size="sm" title="Action failed" ok-only centered>
            <p class="m-2">There was a problem completing the action, Please try again.</p>
        </b-modal>

    </b-modal>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import ErrorView from '../ErrorView'

    export default {
        name: "SessionModal",
        components: {
            ErrorView
        },
        data() {
            return {
                showModal: false,

                title: "Details",

                nameValue: null,
                showValidation: false,
            }
        },
        watch: {
            model(newValue) {
                this.resetModel(newValue);
            },
            showModal(newValue) {
                if(newValue) this.resetModel(this.model);
            }
        },
        computed: {
            ...mapGetters({
                model: 'session/current',
                isModelLoading: 'session/currentLoading',
                isModelLoadingError: 'session/currentLoadingError',
                modelLoadingErrorValue: 'session/currentLoadingErrorValue',
            }),

            isLoading: function() {
                return this.isModelLoading;
            },
            isLoadingError: function() {
                return this.isModelLoadingError;
            },
            loadingErrorValue: function() {
                return this.modelLoadingErrorValue;
            },

            nameState: function () {
                if (this.nameValue && this.nameValue.length > 2 && this.nameValue.length < 128) {
                    return true
                }
                return this.showValidation ? false : null
            },
            validatedValue: function() {

                if(this.isLoading ||this.isLoadingError) {
                    return null;
                }

                if(this.nameState ) {
                    let value = {
                        organizationId: this.model ? this.model.organizationId : undefined,
                        sessionId: this.model ? this.model.sessionId : undefined,
                        name: this.nameValue,
                    };

                    return value;
                }

                return null;
            },
        },
        methods: {
            ...mapActions({
                save: 'session/save',
            }),
            resetModel(newValue) {
                this.showValidation = false;
                if (newValue) {
                    this.title = "Edit Session Details"
                    this.nameValue = newValue.name ?? "";
                } else {
                    this.title = "New Session Details"
                    this.nameValue = null;
                }
            },
            handleOk(bvModalEvt) {

                // Prevent modal from closing
                bvModalEvt.preventDefault()

                if (this.isLoading) {
                    return
                }

                if (this.validatedValue != null) {

                    let self = this;
                    this.save(this.validatedValue)
                        .then(function (success) {
                            if(success) {
                                self.resetModel(null);
                                self.closeModal();
                            } else {
                                self.$bvModal.show('error-modal')
                            }
                        })

                } else {
                    this.showValidation = true;
                }
            },
            handleCancel(bvModalEvt) {
                // Prevent modal from closing
                bvModalEvt.preventDefault()

                if (this.isLoading) {
                    return
                }

                this.closeModal()

            },
            closeModal() {
                this.$nextTick(() => {
                    this.$bvModal.hide('edit-session-modal')
                })
            }
        }
    }
</script>

<style scoped>

</style>